import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PageSizeSelectorComponent } from './page-size-selector/page-size-selector.component';
import { TablePaginationComponent } from './table-pagination/table-pagination.component';
import { LoadingOverlayComponent } from './loading-overlay/loading-overlay.component';
import { NoRecordsOverlayComponent } from './no-records-overlay/no-records-overlay.component';

@NgModule({
  declarations: [
    PageSizeSelectorComponent,
    TablePaginationComponent,
    LoadingOverlayComponent,
    NoRecordsOverlayComponent
  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [
    PageSizeSelectorComponent,
    TablePaginationComponent,
    LoadingOverlayComponent,
    NoRecordsOverlayComponent
  ]
})
export class TableUtilsModule { }
